import { useEffect } from 'react';
import VooksEventFriendReferralIntro from '../../../resources/images/vooks_event_friend_referral_intro.png';
import VooksEventFriendReferralSpeechBubble1 from '../../../resources/images/vooks_event_friend_referral_speech_bubble_1.png';
import VooksEventFriendReferralSpeechBubble2 from '../../../resources/images/vooks_event_friend_referral_speech_bubble_2.png';
import VooksEventFriendReferralKakaoButton from '../../../resources/images/vooks_event_friend_referral_kakao_button.png';
import VooksEventFriendReferralNaverButton from '../../../resources/images/vooks_event_friend_referral_naver_button.png';
import VooksReview from '../../../resources/images/vooks_review.gif';
import VooksOverview from '../../../resources/images/vooks_overview.png';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import VooksFavicon from '../../../resources/favicons/vooks_favicon.ico';

const VooksEventContent = () => {
  const [searchParams] = useSearchParams();

  const codeParam = searchParams.get('code') || '';
  const phoneNumberParam = searchParams.get('phoneNumber') || '';

  useEffect(() => {
    // Kakao SDK 초기화
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init(process.env.REACT_APP_KAKAO_KEY); // 발급받은 JavaScript 키 사용
    }
  }, []);

  const shareToKakao = () => {
    window.Kakao.Link.sendCustom({
      templateId: 114624,
      templateArgs: {
        phoneNumber: phoneNumberParam,
      },
      installTalk: true,
    });
  };

  return (
    <div className={'flex justify-center'}>
      <Helmet>
        <title>Vooks</title>
        <link rel={'icon'} href={VooksFavicon}/>
      </Helmet>
      {codeParam === 'FriendReferral' ? (
        <div className={'max-w-[500px]'}>
          <img src={VooksEventFriendReferralIntro} alt="VooksEventFriendReferralIntro"/>
          <div className={'font-[nanum-square-neo-b] text-[18px] text-center'}>
            이벤트 기간: 2024.12.02 ~ 2024.12.15<br/>
            <span className={'text-[#0071e2]'}>(당첨자 발표: 2024.12.16 * 당첨자 개별 연락)</span>
          </div>
          <div className={'flex justify-center mt-[20px]'}>
            <div className={'px-[10px]'}>
              <div className={'flex justify-center'}>
                <img src={VooksEventFriendReferralSpeechBubble1} alt="VooksEventFriendReferralSpeechBubble1" className={'w-full max-w-[220px]'}/>
              </div>
              <div className={'flex justify-center mt-[10px]'}>
                <img src={VooksEventFriendReferralKakaoButton} alt={'VooksEventFriendReferralKakaoButton'} className={'w-full max-w-[230px] cursor-pointer'} onClick={shareToKakao}/>
              </div>
              <div className={'text-center mt-[10px] text-[12px] text-[gray]'}>
                * 위의 링크로 공유하셔야,<br/>
                고객님의 연락처로 자동 신청됩니다!
              </div>
            </div>
            <div className={'px-[10px]'}>
              <div className={'flex justify-center'}>
                <img src={VooksEventFriendReferralSpeechBubble2} alt="VooksEventFriendReferralSpeechBubble2" className={'w-full max-w-[220px]'}/>
              </div>
              <div className={'flex justify-center mt-[10px]'}>
                <a target="_blank" href={`https://smartstore.naver.com/1promath/products/11122262999?nt_source=vooks&nt_medium=reco&nt_detail=1900&nt_keyword=${phoneNumberParam}`}>
                  <img src={VooksEventFriendReferralNaverButton} alt={'VooksEventFriendReferralNaverButton'} className={'w-full max-w-[230px]'}/>
                </a>
              </div>
              <div className={'text-center mt-[10px] text-[12px] text-[gray]'}>
                * 해당 상품은 특별가로<br/>
                1인당 1개씩만 구입 가능합니다.
              </div>
            </div>
          </div>
          <img src={VooksReview} alt="VooksReview" className={'mt-[40px]'}/>
          <img src={VooksOverview} alt="VooksOverview"/>
        </div>
      ) : null}
    </div>
  );
};

export default VooksEventContent;
